import { render, staticRenderFns } from "./message-product-card.vue?vue&type=template&id=9d0bbf2e&scoped=true"
import script from "./message-product-card.vue?vue&type=script&lang=ts"
export * from "./message-product-card.vue?vue&type=script&lang=ts"
import style0 from "./message-product-card.vue?vue&type=style&index=0&id=9d0bbf2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d0bbf2e",
  null
  
)

export default component.exports